import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { TokenContext } from "./TokenContext";

function FetchReportPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const [jsonData, setJsonData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { setBearerToken, setCsrf } = useContext(TokenContext);

    const getReportParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            reportToken: params.get("token"),   //bearer token
        };
    };

    // 예제 1
    const fetchReportData = async () => {

        // ### 시작 json 데이타 받기  ###
        // endpoint : /report/start/startData
        // method : post
        // body : { reportType, reportToken }

        try {
            setLoading(true);
            setError(null);

            const { reportToken } = getReportParams();

            if (!reportToken) {
                throw new Error("No reportToken (001): 유효하지 않은 요청입니다.");
            }

            const endpoint = "/report/start/startData"; // 가상의 서버 주소
            // const endpoint = `${URL}/report/start/startData`; // 가상의 서버 주소
            // const requestBody = {   // 나중에 확인 필요
            //     token: reportToken,
            //     // reportType: 'SENTENCE',
            //     // reportToken: reportToken
            // };

            const response = await axios.post(endpoint, {
            }, {
                withCredentials: true, // 쿠키 포함 옵션
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${reportToken}`,
                }
            });

            if (response) {
                if (response.data.result) {
                    setJsonData(response.data.data);
                    setBearerToken(reportToken);
                    setCsrf(response.data?.token || null);
                } else {
                    // ('==> 실패 1 ');
                }
            } else {
                // ('==> 실패 2 ');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchReportData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    // jsonData가 설정되면 자동으로 각 페이지로 이동
    useEffect(() => {
        if (jsonData) {
            if (jsonData?.reportType === "REPORT") {
                // 성적표
                navigate("/reportprint", { state: { jsonData } })
            } else {
                // 교재(워크시트)-학생, 시험지-선생님, 자가채점
                navigate("/generalprint", { state: { jsonData } });
            }
        }
    }, [jsonData, navigate]);

    if (loading) {
        return <div>데이터 로드 중...</div>;
    }

    if (error) {
        return <div>404 Not Found</div>;
    }

    return <div>페이지 이동 중...</div>;
}

export default FetchReportPage;
